<template>
  <Modal v-model="visible" :title="editType == 1 ? '新增' : '编辑' + '备案信息'" @on-ok="confirmAdd" :loading="$root.$children[0].modalLoading"
    width="600">
    <Form v-if="visible" ref="form" :model="formInline" label-position="top" :rules="ruleInline">
      <FormItem prop="name" label="备案名称">
        <Input type="text" v-model="formInline.name" @on-blur="event => {
            formInline.name = event.target.value.trim();
          }
          " placeholder="请输入" />
      </FormItem>
      <FormItem prop="filingNumber" label="批复文号/备案编号/产品注册号">
        <Input type="text" v-model="formInline.filingNumber" placeholder="请输入" />
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
export default {
  mixins: [],
  components: {},
  data() {
    return {
      formInline: {
        name: '',
        filingNumber: '',
      },
      visible: false,
      loading: false,
      selIndex: '',
      editType: '',
      ruleInline: {
        name: {
          required: true,
          message: '请输入'
        },
        filingNumber: {
          required: true,
          message: '请输入',
          trigger: 'blur'
        },
      },
    };
  },
  methods: {
    open(row = {}, editType, index = null) {
      this.editType = editType;//1新增  2修改
      if (row.name) {
        this.selIndex = index;
        this.formInline = JSON.parse(JSON.stringify(row));
      } else {
        this.formInline = {};
      }
      this.visible = true;
    },
    async confirmAdd() {
      this.$units.notCloseModal(this);
      //新增附加险
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$emit('success', this.editType, this.formInline, this.selIndex)
          if (this.editType == 1) {
            this.$Message.success('新增成功');
          } else {
            this.$Message.success('修改成功');
          }
          this.visible = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
